import React from 'react';
import { useTranslation } from 'react-i18next';
import { s } from '../helpers';

export interface TierItem {
  cap: number;
  label: string;
  count: number;
  h: string;
  title: string;
  onClick: () => void;
  isSelected?: boolean;
}

export interface CapitalUnderManagementProps {
  fundedCapitalText: string;
  fundedCount: number;
  avgTicket: string;
  openFundedList?: () => void;
  tiers: TierItem[];
}

export const CapitalUnderManagement: React.FC<CapitalUnderManagementProps> = ({
  fundedCapitalText,
  fundedCount,
  avgTicket,
  openFundedList,
  tiers
}) => {
  const { t } = useTranslation();

  return (
    <section
      style={s(
        `background:#FFFEFB;border:1px solid #EFE6D6;border-radius:12px;box-shadow:0 1px 3px rgba(120,90,30,0.06);padding:16px 18px;min-width:0;display:flex;flex-direction:column;gap:12px`
      )}
    >
      <div style={s(`display:flex;align-items:center;justify-content:space-between;gap:8px;flex-wrap:wrap`)}>
        <h2
          style={s(
            `margin:0;font-size:14px;font-weight:700;color:#1B1B1B;text-transform:uppercase;letter-spacing:0.01em`
          )}
        >
          {t('managerNetwork.cum.title', 'Capital Under Management')}
        </h2>
        <span style={s(`font-size:11.5px;color:#6B6358`)}>
          {t('managerNetwork.cum.subtitle', 'Số lượng Capital Managers theo cấp vốn')}
        </span>
      </div>
      <div style={s(`display:flex;flex-wrap:wrap;align-items:center;gap:16px 24px;flex:1`)}>
        <div
          onClick={openFundedList}
          style={s(`display:flex;flex-direction:row;gap:16px;min-width:180px;${openFundedList ? 'cursor:pointer;' : ''}`)}
        >
          <span style={s(`font-size:30px;font-weight:700;color:#A67A2E;letter-spacing:-0.01em;white-space:nowrap`)}>
            {fundedCapitalText}
          </span>
          <div style={s(`display:flex;flex-direction:column;gap:2px;`)}>
            <span style={s(`font-size:11.5px;color:#3A342C;text-transform:uppercase`)}>
              {t('managerNetwork.cum.totalFundedCapital', 'Total Funded Capital')}
            </span>
            <span style={s(`font-size:11.5px;color:#8A8278`)}>
              {t('managerNetwork.cum.accountsAvg', '{{count}} accounts · avg {{avg}}', { count: fundedCount, avg: avgTicket })}
            </span>
          </div>
        </div>
        <div
          style={s(
            `flex:1;min-width:240px;display:grid;grid-template-columns:repeat(${tiers?.length || 6},minmax(0,1fr));gap:10px;align-items:end;height:150px`
          )}
        >
          {tiers?.map((t_item, t_idx) => (
            <React.Fragment key={t_idx}>
              <div
                onClick={t_item.onClick}
                title={t_item.title}
                style={s(
                  `height:100%;display:flex;flex-direction:column;justify-content:flex-end;align-items:center;gap:5px;cursor:pointer;padding:4px 4px;border-radius:8px;transition:all 0.15s;${t_item.isSelected ? 'background:#FBF3E3;box-shadow:0 0 0 1.5px #CFA25A;' : ''}`
                )}
              >
                <span style={s(`font-size:12.5px;font-weight:700;color:${t_item.isSelected ? '#A67A2E' : '#1B1B1B'}`)}>{t_item.count}</span>
                <div
                  style={s(
                    `width:100%;max-width:38px;height:${t_item.h};min-height:4px;background:${t_item.isSelected ? 'linear-gradient(180deg,#D4AF37,#A67A2E)' : 'linear-gradient(180deg,#EACD92,#CFA25A)'};border-radius:2px`
                  )}
                ></div>
                <span style={s(`font-size:11.5px;font-weight:${t_item.isSelected ? '700' : '500'};color:${t_item.isSelected ? '#A67A2E' : '#1B1B1B'};white-space:nowrap`)}>{t_item.label}</span>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};
